<!-- <div class="filter"></div> -->

<div class="d-flex flex-row-reverse">

  <div class="d-flex flex-column justify-content-center bg-white" style="position: relative;width: 100%;height: 330px">
    <div class="d-flex justify-content-center">
      <i class="bi bi-search" style="font-size: 38px;"></i>
    </div>
    <div>
      <p class="mb-0 title">Buscando</p>
      <p class="mb-0 title">{{getCategorySearching()}} en:</p>
    </div>
    <div class="mt-4 mx-auto" style="max-width: 180px;">
        <p *ngIf="category === 1" class="mb-0 destination">{{formData.destination?.city_name}} ({{formData.destination?.country_iata_code}})</p>
        <p *ngIf="category === 2" class="mb-0 destination">{{formData.origin?.city_name || formData.origin?.name}} ({{formData.origin?.country_iata_code || formData.origin?.iata}})</p>
        <p *ngIf="category === 5" class="mb-0 destination">{{formData.legs[0]?.origin?.name}}</p>
        <p *ngIf="category === 6" class="mb-0 destination">{{formData.destination?.city_name}} ({{formData.destination?.country_iata_code}})</p>
        <p *ngIf="category === 8" class="mb-0 destination">{{formData.firstOrigin.city_name || formData.firstOrigin.name || formData.firstOrigin.hotel_name || formData.firstOrigin.display}} ({{data.transfers.pickupLocation.origin}})</p>
        <p *ngIf="category === 9" class="mb-0 destination">{{formData.destination?.city_name}} ({{formData.destination?.country_iata_code}})</p>
        <p *ngIf="category === 10" class="mb-0 destination">{{formData.destination?.label || formData.destination}}</p>
    </div>
    <div class="mt-4">
      <div>
        <p *ngIf="category === 1" class="mb-0 date">Desde: {{ data.arrivalDate || formData.dateStarEnd.start | date:'dd/MM/yyyy' }} hasta: {{data.departureDate || formData?.dateStarEnd?.end | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 2" class="mb-0 date">Desde: {{data.arrivalDate | date:'dd/MM/yyyy' }} hasta: {{data.departureDate | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 5" class="mb-0 date">Partida: {{payload[0]?.legs[0]?.date | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 6" class="mb-0 date">Desde: {{formData.arrivalDateDepartureDate.start | date:'dd/MM/yyyy'}} hasta: {{formData.arrivalDateDepartureDate.end | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 8" class="mb-0 date">Desde: {{formData.firstArrivalDate | date: 'dd/MM/yyyy'}} hasta: {{(formData.secondArrivalDate ? formData.secondArrivalDate : formData.firstArrivalDate) | date: 'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 9" class="mb-0 date">Desde: {{formData.arrivalDateDepartureDate.start | date:'dd/MM/yyyy'}} hasta: {{formData.arrivalDateDepartureDate.end | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 10" class="mb-0 date">Desde: {{formData.beginDateEndDate.start | date:'dd/MM/yyyy'}} hasta: {{formData.beginDateEndDate.end | date:'dd/MM/yyyy'}}</p>
      </div>
      <div>
        <p *ngIf="category === 1" class="mb-0 product-configuration">Habitaciones {{data? data.qtyProduct : '' }} | {{adults }} {{ adults == 1 ?   'Adulto' : 'Adultos'  }}  {{validateChildren(children)}} </p>
        <p *ngIf="category === 2" class="mb-0 product-configuration">Edad del conductor: {{formData.age}} años </p>
        <p *ngIf="category === 2 && ageDriver >= 21 && ageDriver <=24" class="mb-0 product-configuration">Algunas compañías podrían aplicar cargos extras en destino si el conductor tiene entre 21 y 24 años.</p>
        <p *ngIf="category === 5" class="mb-0 product-configuration">Adultos {{formData.passengers?.adults }} | Niños {{formData?.passengers?.childrens > 0 ? formData?.passengers?.childrens : 0}}</p>
        <p *ngIf="category === 6" class="mb-0 product-configuration">Adultos {{formData.qtyAdults }} | Niños {{formData.qtyChilds}}</p>
        <p *ngIf="category === 8" class="mb-0 product-configuration">Vehículos 1 | Adultos {{ adults }} | Niños {{ children }} </p>
        <p *ngIf="category === 9" class="mb-0 product-configuration">Adultos {{formData.qtyAdults }} | Niños {{formData.qtyChilds}}</p>
        <p *ngIf="category === 10" class="mb-0 product-configuration">{{formData.qtyPax }} {{formData.qtyPax === 1 ? 'Pasajero' : 'Pasajeros'}} | {{formData.serviceType}}</p>
      </div>

    </div>


  </div>
  <div style="width: 50%; height: 330px; flex-shrink: 0;" *ngIf="!imgZone">
            <img style="width: 100%; height: 100%; object-fit: cover;"
                [src]="agencyImagen"
                alt="">
  </div>
  <div style="width: 50%; height: 330px; flex-shrink: 0;" *ngIf="imgZone">

    <div style="width: 100%; height: 100%;">
      <owl-carousel-o
                     [options]="customOptionsModalLoading"
                     #owlElement
                     style="width: 100%; height: 100%;">
      <ng-container *ngFor="let slide of imgZonesArr" >
        <ng-template carouselSlide>
          <div style="width: 100%; height: 330px;">
            <img style="width: 100%; height: 100%; object-fit: cover;"
                [src]="slide"
                alt="">
          </div>
        </ng-template>

      </ng-container>

      </owl-carousel-o>
    </div>
  </div>
</div>
